import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default ({ isMinimal, isUnbranded }) => css`
  color: ${colors.heatherField};

  .cr-logo-svg {
    fill: ${colors.white};

    @media (hover: hover) {
      &:hover {
        fill: ${colors.orange};
      }
    }
  }

  .link-section {
    border-color: ${colors.shark};

    &-title {
      color: ${colors.white};
    }
  }

  .footer-bottom {
    border-color: ${colors.trout};

    a,
    [tabindex='0'] {
      color: ${colors.heatherField};

      &:focus {
        color: ${colors.white};
      }

      @media (hover: hover) {
        &:hover {
          color: ${colors.white};
        }
      }
    }

    .item-upsell {
      color: ${colors.honeyGold};
    }
  }

  li:not(:last-of-type)::after {
    background-color: ${(isMinimal || isUnbranded) && colors.trout};
  }

  .copyright-text::before {
    background-color: ${colors.trout};
  }

  .sony-logo path {
    fill: ${colors.heatherField};
  }
`
